import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Utility function to create a container formatter that uses a specific card formatter
 *
 * @param ContainerFormatter - The original container formatter component
 * @param CardFormatter - The card formatter component to be injected
 * @returns A new container formatter component that delegates to the original one but with the specified card formatter
 *
 * @example
 * ```tsx
 * // Create a list layout that uses GridCardFormatter for all cards
 * const GridCardListFormatter = withCardFormatter(CardListContainerFormatter, GridCardFormatter);
 *
 * // Use in a component
 * <CrmCardContainer
 *   formatterRegistry={{
 *     ...DEFAULT_CONTAINER_FORMATTERS,
 *     LIST: GridCardListFormatter
 *   }}
 *   // other props...
 * />
 * ```
 */
export function withCardFormatter(ContainerFormatter, CardFormatter) {
  // Create a new container formatter component
  const EnhancedContainerFormatter = props => {
    // Pass all original props plus the injected CardFormatter to the original container formatter
    return /*#__PURE__*/_jsx(ContainerFormatter, Object.assign({}, props, {
      CardFormatter: CardFormatter
    }));
  };

  // Set a display name for debugging purposes
  const containerName = ContainerFormatter.displayName || ContainerFormatter.name || 'ContainerFormatter';
  const cardName = CardFormatter.displayName || CardFormatter.name || 'CardFormatter';
  EnhancedContainerFormatter.displayName = `with${cardName}(${containerName})`;
  return EnhancedContainerFormatter;
}